import { type FC, type PropsWithChildren, useContext } from 'react'

import {
  LOGIN_OTP_STATE,
  LoginRegistrationUserLoginStateContext,
} from '../../context/LoginRegistrationUserLoginStateContext'
import { type LoginAfterLoggedIn } from '../../loginAfterLoggedIn'
import { LoginRegistrationOneTimePasswordInputForm } from '../LoginRegistrationOneTimePasswordInputForm/LoginRegistrationOneTimePasswordInputForm'
import { LoginRegistrationOneTimePasswordRequestForm } from '../LoginRegistrationOneTimePasswordRequestForm/LoginRegistrationOneTimePasswordRequestForm'
import { LoginRegistrationUserLoginForm } from '../LoginRegistrationUserLoginForm/LoginRegistrationUserLoginForm'

interface LoginRegistrationLoginRenderSwitchProps {
  afterLoggedIn?: LoginAfterLoggedIn
}

export const LoginRegistrationLoginRenderSwitch: FC<
  PropsWithChildren<LoginRegistrationLoginRenderSwitchProps>
> = ({ afterLoggedIn, children }) => {
  const { loginOtpState } = useContext(LoginRegistrationUserLoginStateContext)

  switch (loginOtpState) {
    case LOGIN_OTP_STATE.LOGIN_REGISTER: {
      return (
        <LoginRegistrationUserLoginForm afterLoggedIn={afterLoggedIn}>
          {children}
        </LoginRegistrationUserLoginForm>
      )
    }
    case LOGIN_OTP_STATE.OTP_INPUT: {
      return (
        <LoginRegistrationOneTimePasswordInputForm
          afterLoggedIn={afterLoggedIn}
        />
      )
    }
    case LOGIN_OTP_STATE.OTP_REQUEST: {
      return <LoginRegistrationOneTimePasswordRequestForm />
    }
    case LOGIN_OTP_STATE.OTP_REQUEST_NEW_CODE: {
      return <LoginRegistrationOneTimePasswordRequestForm isReRequest />
    }
    default: {
      return <LoginRegistrationUserLoginForm />
    }
  }
}
